import { Link as TanstackLink, LinkProps as TanstackLinkProps } from "@tanstack/react-router";
import { Link as MUILink, LinkProps as MUILinkProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

// Omitindo propriedades conflitantes, como `target` e `children`
interface LinkProps
  extends Omit<MUILinkProps, "children" | "target">,
    Omit<TanstackLinkProps, "children" | "target"> {
  children: React.ReactNode;
  target?: React.HTMLAttributeAnchorTarget | undefined;
}

// Criar um componente Link estilizado que usa MUI e Tanstack
const StyledLink = styled(MUILink)(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline",
  },
}));

export const RouterLink = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, children, ...rest }, ref) => {
    return (
      // @ts-expect-error: `component` faz override do root element do MUI Link
      <StyledLink ref={ref} component={TanstackLink} to={to ?? rest.href} {...rest}>
        {children}
      </StyledLink>
    );
  },
);
RouterLink.displayName = "RouterLink";
